import React from "react";

const fmt = require("indian-number-format");

export default function Total(props) {
  const profitloss = props.profitloss == null ? 0 : props.profitloss;
  const commission = props.commission == null ? 0 : props.commission;

  const total = parseFloat(
    parseFloat(Math.abs(profitloss)) - parseFloat(commission)
  ).toFixed(0);

  return (
    <div
      className="settlementItem text"
      style={{
        marginTop: 10,
        height: 30,
        width: 450,
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ flex: 1, paddingLeft: 10 }} className="large">
        Total
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        className="large primarytext"
      >
        {fmt.format(Math.abs(total))}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingRight: 10,
        }}
        className="large primarytext"
      >
        {fmt.format(commission)}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingRight: 10,
        }}
        className="large primarytext"
      >
        {fmt.format(Math.abs(profitloss))}
      </div>
    </div>
  );
}
